import { COMPOENT_THEME, ButtonType } from '@umu/umu-design';
import { Dayjs } from 'dayjs';
enum PickerPanelType {
    start,
    end,
}
enum PlacementTypes {
    top = 'top',
    right = 'right',
    bottom = 'bottom',
    left = 'left',
}
enum DateMode {
    signal = 'signal',
    multiple = 'multiple',
}
type DateValue = Dayjs | null;
type DateRange = [DateValue, DateValue];

interface IMobileBasicInfo {
    preCls?: string;
    theme?: COMPOENT_THEME;
    defaultValue?: DateRange;
    dateFormat?: string;
    placeholder?: [string, string] | string;
    disabledDate?: (current: Dayjs) => boolean;
    onChange?: (value?: DateRange) => void;
    mode?: DateMode;
    // 清空按钮配置
    clearBtn?: {
        show?: boolean;
        text?: string;
        type?: ButtonType;
        onClick?: (info?: { onClose?: () => void; onChange?: (value?: DateRange) => void }) => void;
    };
    renderContent?: (value: DateRange) => JSX.Element;
}
export { DateMode, DateRange, DateValue, PickerPanelType, IMobileBasicInfo, PlacementTypes };
